/* eslint-disable no-restricted-globals */
/* eslint-disable no-unsafe-optional-chaining */
import React, { useEffect, useState } from "react";

import {
  ChevronLeft,
  Language,
  LocationOnOutlined,
  NoteOutlined,
} from "@mui/icons-material";
import {
  Box,
  Card,
  Button,
  Typography,
  IconButton,
  Divider,
  Rating,
  Skeleton,
  CircularProgress,
  Tooltip,
  Grid,
  useTheme,
  Alert,
} from "@mui/material";
import dayjs from "dayjs";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import { connect, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import ASSESSMENTICON from "../../assets/icons/assessmenticon.png";
import INFOICON from "../../assets/icons/info.png";
import RESUMEICON from "../../assets/icons/resumeicon.png";
import { EmptyState } from "../../common";
import CandidateInformationSection from "../../common/CandidateInformationSection";
import InterviewQnaCard from "../../common/InterviewQnaCard";
import SegmentedProgressBar from "../../common/SegmentedProgressBar";
import AttachmentsModal from "../../components/Modals/CandidateAttachementsModal";
import {
  getSingleResume as getSingleResumeAction,
  selectResumeById,
} from "../../redux/slices/resumeSlice";
import { profiles } from "../../static/socials-profiles";
import {
  endReasonMessages,
  getCamelCaseWord,
  hardcodedViolations,
  metricColors,
} from "../../utils/functions";
import "../../common/share-button.css";
import ShareResultModal from "../../common/ShareResultModal";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
/* ============================================================================
<InterviewResultsCandidateOverallResult />
============================================================================= */
const InterviewResultsCandidateOverallResult = ({ user, getSingleResume }) => {
  const { resumeId } = useParams();
  const navigate = useNavigate();
  const [attachmentsModal, setAttachementsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const theme = useTheme();
  const [openShareModal, setOpenShareModal] = useState(false);

  const _toggleAttachementsModal = () => setAttachementsModal((prev) => !prev);
  const _toggleShareModal = () => setOpenShareModal((prev) => !prev);

  const resume = useSelector((state) => selectResumeById(state, resumeId));
  const post = resume?.job;
  const isResumeScoreCalculated =
    typeof resume?.score === "object" &&
    Object?.keys(resume?.score || {}).length > 0;

  const socials =
    resume?.candidate?.social_profiles?.map((c) => ({
      ...c,
      isValid: c?.url && c?.url !== "N/A",
    })) || [];

  const violations_detected = resume?.result?.length
    ? resume?.result[0]?.violations_detected || {}
    : {};

  // Merge hardcoded violations with detected ones
  const allViolations = { ...hardcodedViolations, ...violations_detected };

  const test =
    Array.isArray(resume?.result) && resume.result.length > 0
      ? [...resume.result[0]?.tests]?.sort(
          (a, b) => (b?.test_score || 0) - (a?.test_score || 0)
        )
      : [];

  console.log("test ------>", test);

  useEffect(() => {
    _getData();
    // setIsLoading(false)
  }, []);

  const _getData = async () => {
    setIsLoading(true);
    await getSingleResume(resumeId);
    setIsLoading(false);
  };

  const attachements = [
    {
      name: "Image.png",
      type: "image/png",
      url: "https://images.unsplash.com/photo-1559583985-c80d8ad9b29f?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      name: "Certificate.png",
      type: "image/png",
      url: "https://plus.unsplash.com/premium_photo-1686729237226-0f2edb1e8970?q=80&w=1934&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      name: "portfolio.pdf",
      type: "pdf",
      url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    },
  ];

  const extracted_data = resume?.resume?.extracted_data
    ? resume?.resume?.extracted_data
    : resume?.candidate;

  const metrics = Object.entries(
    resume?.result?.[0]?.assesment_behaviour_score || {} // Ensure it's an object
  )?.map(([key, value]) => ({
    name: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize first letter
    value: value?.toFixed(2), // Handle possible undefined value
    color: metricColors[key] || "#ccc", // Fallback color
  }));

  // Split into two columns dynamically
  const leftColumnMetrics = metrics?.slice(0, 3);
  const rightColumnMetrics = metrics?.slice(3);
  const reasonData =
    endReasonMessages[resume?.result[0]?.interview_ended_reason];

  if (!resume && !isLoading) {
    return (
      <Box className="center" height="89vh">
        <EmptyState title="Look's like the interivew submition was deleted" />
      </Box>
    );
  }

  return (
    <>
      <Sidebar />
      <Navbar />
      <Card
        sx={{
          m: 3,
          height: "90%",
          borderRadius: "10px",
          ml: { xs: 0, md: "220px" },
        }}
      >
        <Card
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            px: { xs: 2, md: 4 },
            py: 2,
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            gap={{ xs: 0, md: 2 }}
            flexDirection={{ xs: "column", md: "row" }}
          >
            <Box>
              <IconButton
                size="small"
                sx={{ border: "1px solid #B1B1B1" }}
                // onClick={() => navigate(-1)}
                onClick={() =>
                  navigate(
                    `/interview-candidates/${resume?.assessment_id}/assessment`
                  )
                }
              >
                <ChevronLeft sx={{ fontSize: 18, color: "#2d2d2d" }} />
              </IconButton>
            </Box>

            <Box>
              <Typography fontSize="18px" fontWeight={600} color="#48555E">
                {resume?.candidate_name ? resume?.candidate_name : "--"}
              </Typography>
              <Typography fontSize="14px" fontWeight={500} color="#48555E">
                {extracted_data?.candidate_email || extracted_data?.email}
              </Typography>
            </Box>
            <Box>
              {extracted_data?.total_relevant_experience?.value ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <NoteOutlined sx={{ fontSize: "15px", color: "#48555E" }} />
                  <Typography fontSize="14px" fontWeight={600} color="#48555E">
                    {
                      resume?.resume?.extracted_data?.total_relevant_experience
                        ?.value
                    }
                  </Typography>
                </Box>
              ) : null}
              {extracted_data?.address?.value ||
              extracted_data?.location?.value ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <LocationOnOutlined
                    sx={{ fontSize: "15px", color: "#48555E" }}
                  />
                  <Typography fontSize="14px" fontWeight={600} color="#48555E">
                    {extracted_data?.address?.value ||
                      extracted_data?.location?.value}
                  </Typography>
                </Box>
              ) : null}
            </Box>
          </Box>

          {(resume?.resume_score || resume?.result[0]?.tests?.length > 0) && (
            <Box
              display="flex"
              gap={2}
              justifyContent="center"
              alignItems="center"
            >
              {/* <button
              type="button"
              className="button"
              onClick={() => setOpenShareModal(true)}
            >
              <span className="fold"></span>

              <div className="points_wrapper">
                <i className="point"></i>
                <i className="point"></i>
                <i className="point"></i>
                <i className="point"></i>
                <i className="point"></i>
                <i className="point"></i>
                <i className="point"></i>
                <i className="point"></i>
                <i className="point"></i>
                <i className="point"></i>
              </div>

              <span className="inner">
                <svg
                  className="icon"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2.5"
                >
                  <polyline points="13.18 1.37 13.18 9.64 21.45 9.64 10.82 22.63 10.82 14.36 2.55 14.36 13.18 1.37"></polyline>
                </svg>
                Share
              </span>
            </button> */}
            </Box>
          )}
        </Card>
        <Box display="flex">
          <Box p={4} flexBasis="20%" flexGrow={1} height="70vh" overflow="auto">
            <Box mb={3}>
              <Typography fontWeight={600} fontFamily="Outfit" fontSize={20}>
                Personal Info
              </Typography>
            </Box>

            <CandidateInformationSection
              interview={true}
              extracted_data={extracted_data}
            />

            <Box mb={3}>
              <Typography fontWeight={600} fontSize="14px" mb={1}>
                Invited
              </Typography>
              {isLoading ? (
                <Skeleton animation="wave" width="100%" height="30px" />
              ) : (
                <Typography fontSize="13px" fontFamily="Outfit">
                  {dayjs(resume?.created_at).format("LL")}
                </Typography>
              )}
            </Box>
            <Box mb={3}>
              <Typography fontWeight={600} fontSize="14px" mb={1}>
                Completed
              </Typography>
              {isLoading ? (
                <Skeleton animation="wave" width="100%" height="30px" />
              ) : (
                <Typography fontSize="13px" fontFamily="Outfit">
                  {resume?.interview_attempted
                    ? dayjs(resume?.interview_attempted).format("LL")
                    : "--"}
                </Typography>
              )}
            </Box>
            <Box mb={3}>
              <Typography fontWeight={600} fontSize="14px" mb={1}>
                Source
              </Typography>
              {isLoading ? (
                <Skeleton animation="wave" width="100%" height="30px" />
              ) : (
                <Typography fontSize="13px" fontFamily="Outfit">
                  Invitation by email
                </Typography>
              )}
            </Box>
          </Box>

          {isLoading ? (
            <Box
              flexBasis="90%"
              flexGrow={1}
              height="70vh"
              overflow="auto"
              className="center"
            >
              <CircularProgress size={35} />
            </Box>
          ) : (
            <Box
              flexBasis="90%"
              flexGrow={1}
              p={3}
              height="70vh"
              overflow="auto"
            >
              <Box display="flex" alignItems="center" gap={2} mb={2}>
                <Typography
                  variant="h4"
                  fontWeight={700}
                  fontFamily="Outfit"
                >
                  Overall Result
                </Typography>
              </Box>

              {reasonData && (
                <Alert
                  icon={<Box component="img" src={INFOICON} height={50} />}
                  severity="info"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#FFFCF4",
                    color: "#4B5563",
                    border: "1px solid #F59E0B",
                    borderRadius: "8px",
                    padding: "16px",
                    maxWidth: "100%",
                    p: 2,
                    mb: 3,
                  }}
                >
                  <Box sx={{ ml: 1 }}>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{ color: "#535251", fontFamily: "Outfit" }}
                    >
                      {reasonData.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="#354652"
                      fontFamily="Outfit"
                      mb={1}
                    >
                      {reasonData.description}
                    </Typography>
                  </Box>
                </Alert>
              )}

              <Box
                display="flex"
                my={3}
                gap={2.5}
                flexDirection={{ md: "row", sm: "column", xs: "column" }}
              >
                {resume?.resume_score && (
                  <Box width="100%">
                    <Box display="flex" alignItems="center" gap={1.5} mb={1}>
                      <img src={RESUMEICON} height={40} />
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        fontFamily="Outfit"
                      >
                        Resume Score
                      </Typography>
                    </Box>

                    <Card
                      sx={{
                        bgcolor: "#FBFBFB",
                        px: { xs: 2, md: 5 },
                        py: 3,
                        gap: 2,
                        border: 1,
                        borderColor: "#DDE3E5",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        width={{ xs: "100px", sm: "200px", md: "250px" }}
                        height={{ xs: "100px", sm: "200px", md: "250px" }}
                      >
                        <CircularProgressbarWithChildren
                          value={resume?.resume_score || 0}
                          strokeWidth={12}
                          styles={buildStyles({
                            rotation: 0.75,
                            strokeLinecap: "round",
                            pathColor: `#4BC7E1`,
                            trailColor: "#DEF7FC",
                          })}
                        >
                          <Typography
                            color="#4BC7E1"
                            textAlign="center"
                            fontSize={{ xs: "18px", md: "38px" }}
                            fontWeight={700}
                            mb={1.4}
                          >
                            {`${Math.floor(resume?.resume_score || 0)}%`}
                            <Typography
                              fontSize={{ xs: "10px", md: "15px" }}
                              fontWeight={500}
                            >
                              Average Score
                            </Typography>
                          </Typography>
                        </CircularProgressbarWithChildren>
                      </Box>
                      <Box>
                        {isResumeScoreCalculated
                          ? Object.keys(resume?.score || {})
                              .slice(0, 4)
                              .sort(
                                (a, b) =>
                                  resume?.score[b]?.matching_score >
                                  resume?.score[a]?.matching_score
                              )
                              ?.map((c, i) => (
                                <Box
                                  key={i}
                                  sx={{
                                    mb: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1.5,
                                  }}
                                >
                                  <Box
                                    width="3px"
                                    height="3px"
                                    bgcolor="#000"
                                    borderRadius="50%"
                                  />
                                  <Typography
                                    fontSize={{ xs: "0.6rem", md: ".8rem" }}
                                    fontWeight={500}
                                    flex={1}
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                  >
                                    {c === "skills"
                                      ? "Technical Skills"
                                      : getCamelCaseWord(c)}
                                  </Typography>
                                  <Box
                                    width={{ xs: "40px", md: "45px" }}
                                    height={{ xs: "40px", md: "45px" }}
                                  >
                                    <CircularProgressbarWithChildren
                                      value={resume?.score[c]?.matching_score}
                                      strokeWidth={10}
                                      styles={buildStyles({
                                        rotation: 0.75,
                                        strokeLinecap: "round",
                                        pathColor: `#4BC7E1`,
                                        trailColor: "#DEF7FC",
                                      })}
                                    >
                                      <Typography
                                        color="#000"
                                        textAlign="center"
                                        fontSize={{ xs: "0.6rem" }}
                                        fontWeight={400}
                                        mb={1.4}
                                      >
                                        {`${Math.floor(
                                          resume?.score[c]?.matching_score
                                        )}%`}
                                      </Typography>
                                    </CircularProgressbarWithChildren>
                                  </Box>
                                </Box>
                              ))
                          : post?.job_criteria?.slice(0, 4)?.map((c, i) => (
                              <Box
                                key={i}
                                item
                                sx={{
                                  display: "flex",
                                  mb: 1,
                                  alignItems: "center",
                                  gap: 1.5,
                                }}
                              >
                                <Box
                                  width="3px"
                                  height="3px"
                                  bgcolor="#000"
                                  borderRadius="50%"
                                />
                                <Typography
                                  fontSize={{ xs: "0.6rem", md: ".8rem" }}
                                  fontWeight={500}
                                  flex={1}
                                  display="flex"
                                  maxWidth="120px"
                                  alignItems="center"
                                  gap={1}
                                >
                                  {getCamelCaseWord(c?.name)}
                                </Typography>
                                <Box
                                  width={{ xs: "40px", md: "40px" }}
                                  height={{ xs: "40px", md: "40px" }}
                                >
                                  <CircularProgressbarWithChildren
                                    value={0}
                                    strokeWidth={10}
                                    styles={buildStyles({
                                      rotation: 0.75,
                                      strokeLinecap: "round",
                                      pathColor: `#4BC7E1`,
                                      trailColor: "#DEF7FC",
                                    })}
                                  >
                                    <Typography
                                      color="#4BC7E1"
                                      textAlign="center"
                                      fontSize={{ xs: "0.6rem" }}
                                      fontWeight={400}
                                      mb={1.4}
                                    >
                                      {`${Math.floor(0)}%`}
                                    </Typography>
                                  </CircularProgressbarWithChildren>
                                </Box>
                              </Box>
                            ))}
                        <Button
                          variant="main"
                          sx={{
                            bgcolor: "#4DD0E1",
                            color: "white",
                            textWrap: "noWrap",
                            borderRadius: "50px",
                            border: "1px solid transparent",
                            py: 1.5,
                            px: { xs: 1, lg: 4 },
                            fontSize: "1em",
                            fontWeight: 500,
                            ml: "2%",
                            "&:hover": {
                              bgcolor: "#26C6DA",
                            },
                          }}
                          onClick={() => {
                            const updatedPath = location.pathname.replace(
                              "/interview-candidates/",
                              "/resume-screening-candidates/"
                            );
                            navigate(`${updatedPath}/full-report`);
                          }}
                        >
                          See full report
                        </Button>
                      </Box>
                    </Card>
                  </Box>
                )}
                <Box width="100%">
                  <Box display="flex" alignItems="center" gap={1.5} mb={1}>
                    <img src={ASSESSMENTICON} height={40} />
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      fontFamily="Outfit"
                    >
                      Assessment Score
                    </Typography>
                  </Box>
                  <Card
                    sx={{
                      bgcolor: "#FBFBFB",
                      px: { xs: 2, md: 5 },
                      py: 3,
                      border: 1,
                      gap: 2,
                      borderColor: "#DDE3E5",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      minWidth={{ xs: "100px", sm: "200px", md: "250px" }}
                      minHeight={{ xs: "100px", sm: "200px", md: "250px" }}
                    >
                      <CircularProgressbarWithChildren
                        value={resume?.interview_score || 0}
                        strokeWidth={12}
                        styles={buildStyles({
                          rotation: 0.75,
                          strokeLinecap: "round",
                          pathColor: `#9048FB`,
                          trailColor: "#E6D5FF",
                        })}
                      >
                        <Typography
                          color="#9048FB"
                          textAlign="center"
                          fontSize={{ xs: "18px", md: "38px" }}
                          fontWeight={700}
                          mb={1.4}
                        >
                          {`${Math.floor(resume?.interview_score || 0)}%`}
                          <Typography
                            fontSize={{ xs: "10px", md: "15px" }}
                            fontWeight={500}
                          >
                            Average Score
                          </Typography>
                        </Typography>
                      </CircularProgressbarWithChildren>
                    </Box>
                    <Box
                      display={"flex"}
                      flexDirection={!resume?.resume_score ? "row" : "column"}
                      alignItems="center"
                      minHeight={{ xs: "auto", md: "245px" }}
                      justifyContent="space-between"
                      gap={3}
                    >
                      <Grid
                        container
                        spacing={2}
                        justifyContent="space-between"
                      >
                        {resume?.result?.length
                          ? [...(resume?.result[0]?.tests || [])]
                              ?.sort((a, b) => b.test_score - a.test_score)
                              ?.map((test) => (
                                <Grid
                                  item
                                  size={{
                                    xs: 8,
                                    md: resume?.resume_score ? 12 : 12,
                                  }}
                                  key={test?.test_id}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1.5,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      position: "relative",
                                      paddingLeft: "1rem",
                                      fontSize: { xs: "0.6rem", md: ".75rem" },
                                      fontWeight: 500,
                                      flex: 1,
                                      maxWidth: "130px",
                                      display: "inline-block",
                                      "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        left: 0,
                                        top: "0.5em", // aligns with the top line
                                        width: "4px",
                                        height: "4px",
                                        backgroundColor: "#000",
                                        borderRadius: "50%",
                                      },
                                    }}
                                  >
                                    {getCamelCaseWord(test?.test_name)}
                                  </Typography>

                                  <Box
                                    width={{ xs: "40px", md: "45px" }}
                                    height={{ xs: "40px", md: "45px" }}
                                  >
                                    <CircularProgressbarWithChildren
                                      value={test?.test_score || 0}
                                      strokeWidth={10}
                                      styles={buildStyles({
                                        rotation: 0.75,
                                        strokeLinecap: "round",
                                        pathColor: `#9048FB`,
                                        trailColor: "#E6D5FF",
                                      })}
                                    >
                                      <Typography
                                        color="#000"
                                        textAlign="center"
                                        fontSize={{ xs: "0.6rem" }}
                                        fontWeight={400}
                                        mb={1.4}
                                      >
                                        {`${Math.floor(
                                          test?.test_score || 0
                                        )}%`}
                                      </Typography>
                                    </CircularProgressbarWithChildren>
                                  </Box>
                                </Grid>
                              ))
                          : null}
                      </Grid>
                      {!resume?.resume_score && (
                        <Divider
                          orientation="vertical"
                          sx={{ minHeight: "150px" }}
                        />
                      )}
                      <Button
                        variant="main"
                        disabled={!resume?.result[0]?.tests?.length > 0}
                        sx={{
                          bgcolor: "#8B5CF6",
                          color: "white",
                          textWrap: "noWrap",
                          borderRadius: "50px",
                          border: "1px solid transparent",
                          py: 1.5,
                          px: { xs: 1, lg: 4 },
                          fontSize: "1em",
                          fontWeight: 500,
                          ml: "2%",
                          "&:hover": {
                            bgcolor: "#A78BFA",
                          },
                        }}
                        onClick={() =>
                          navigate(`${location.pathname}/full-report`)
                        }
                      >
                        See full report
                      </Button>
                    </Box>
                  </Card>
                </Box>
              </Box>

              {metrics?.length > 0 && (
                <Box sx={{ width: "100%", py: 2 }}>
                  <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                    Behaviors Analysis
                  </Typography>

                  <Card
                    sx={{
                      bgcolor: "#FBFBFB",
                      px: { xs: 2, md: 5 },
                      py: 3,
                      border: 1,
                      borderColor: "#DDE3E5",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      overflow: "auto",
                    }}
                  >
                    <Grid container spacing={4}>
                      {/* Circular progress section */}
                      <Grid
                        item
                        xs={12}
                        md={3}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          width={{ xs: "120px", sm: "140px", md: "165px" }}
                          height={{ xs: "120px", sm: "140px", md: "165px" }}
                        >
                          <CircularProgressbarWithChildren
                            value={
                              resume?.result[0]?.overall_behaviour_score || 0
                            }
                            strokeWidth={10}
                            styles={buildStyles({
                              rotation: 0.75,
                              strokeLinecap: "round",
                              pathColor: `#FFB200`,
                              trailColor: "#F1F1F1",
                            })}
                          >
                            <Typography
                              color="#FFB200"
                              textAlign="center"
                              fontSize={{ xs: "18px", md: "38px" }}
                              fontWeight={700}
                              mb={1.4}
                            >
                              {`${Math.floor(
                                resume?.result[0]?.overall_behaviour_score || 0
                              )}%`}
                              <Typography
                                fontSize={{
                                  xs: "10px",
                                  sm: "13px",
                                  md: "13px",
                                }}
                                fontWeight={500}
                              >
                                Average score
                              </Typography>
                            </Typography>
                          </CircularProgressbarWithChildren>
                        </Box>
                      </Grid>

                      {/* Left column metrics (3) */}
                      <Grid item xs={12} md={4.5}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                          }}
                        >
                          {leftColumnMetrics.map((metric) => (
                            <Box
                              key={metric.name}
                              sx={{
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{ width: 120, color: "text.secondary" }}
                              >
                                {metric.name}
                              </Typography>
                              <SegmentedProgressBar
                                value={metric.value}
                                color={metric.color}
                              />
                            </Box>
                          ))}
                        </Box>
                      </Grid>

                      {/* Right column metrics (2) */}
                      <Grid item xs={12} md={4.5}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                          }}
                        >
                          {rightColumnMetrics?.map((metric) => (
                            <Box
                              key={metric.name}
                              sx={{ alignItems: "center" }}
                            >
                              <Typography
                                sx={{ width: 120, color: "text.secondary" }}
                              >
                                {metric.name}
                              </Typography>
                              <SegmentedProgressBar
                                value={metric.value}
                                color={metric.color}
                              />
                            </Box>
                          ))}
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Box>
              )}

              {socials?.length > 0 && (
                <Box sx={{ width: "100%", py: 4 }}>
                  <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                    Social Profiles
                  </Typography>

                  <Box
                    sx={{ display: "flex", gap: 2, overflowX: "auto", pb: 2 }}
                  >
                    {profiles.map((profile, index) => {
                      const matchedProfile = socials.find(
                        (social) =>
                          social?.name?.toLowerCase() ===
                          profile?.name?.toLowerCase()
                      );
                      const url = matchedProfile?.url || "";
                      const isValidUrl = !!url && url !== "N/A";

                      return (
                        <Box
                          key={index}
                          sx={{
                            minWidth: 200,
                            p: 3,
                            borderRadius: 2,
                            backgroundColor: profile.bgColor || "#F1F5F9",
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                          }}
                        >
                          <Box sx={{ color: profile.iconColor || "#0077B5" }}>
                            {profile.icon || <Language sx={{ fontSize: 44 }} />}
                          </Box>
                          <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {profile.name}
                          </Typography>
                          <Tooltip
                            title={
                              !isValidUrl ? "URL not provided by the user." : ""
                            }
                          >
                            <span>
                              <Button
                                variant="contained"
                                sx={{
                                  width: "100%",
                                  backgroundColor: isValidUrl
                                    ? profile.buttonBg || "#0077B5"
                                    : "#B0BEC5",
                                  color: "white",
                                  borderRadius: "30px",
                                  textTransform: "none",
                                  "&:hover": {
                                    backgroundColor: isValidUrl
                                      ? profile.buttonBg || "#0077B5"
                                      : "#B0BEC5",
                                    opacity: isValidUrl ? 0.9 : 1,
                                  },
                                }}
                                onClick={() =>
                                  isValidUrl && window.open(url, "_blank")
                                }
                                disabled={!isValidUrl}
                              >
                                {"View"}
                              </Button>
                            </span>
                          </Tooltip>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              )}
              <Box
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                gap={4}
                alignItems="flex-start"
              >
                <Box
                  width={{
                    xs: "100%",
                    md: resume?.result[0]?.tests?.length > 0 ? "40%" : "100%",
                  }}
                >
                  <Typography fontSize="26px" fontWeight={700}>
                    Anti-Cheating Monitor
                  </Typography>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    mt={1.5}
                    alignItems="center"
                  >
                    <Typography
                      fontSize="14px"
                      fontFamily="Outfit"
                      fontWeight={400}
                    >
                      Device used
                    </Typography>
                    <Typography fontSize="14px" fontFamily="Outfit">
                      Desktop
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    mt={1}
                    alignItems="center"
                  >
                    <Typography
                      fontSize="14px"
                      fontFamily="Outfit"
                      fontWeight={400}
                    >
                      Location
                    </Typography>
                    <Typography fontSize="14px" fontFamily="Outfit">
                      Karachi (SD), PK
                    </Typography>
                  </Box>
                  <Divider sx={{ my: 3 }} />
                  {typeof allViolations == "object"
                    ? Object.keys(allViolations || {})?.map((ass) => (
                        <Box
                          key={ass}
                          display="flex"
                          justifyContent="space-between"
                          mt={1.5}
                          alignItems="center"
                        >
                          <Typography
                            fontSize="14px"
                            fontFamily="Outfit"
                            fontWeight={400}
                          >
                            {ass === "full_screen"
                              ? "Full-screen mode always active ?"
                              : ass}
                          </Typography>

                          <Box
                            sx={{
                              bgcolor: allViolations[ass]
                                ? "#AAE47A"
                                : "#FF8686",
                              fontSize: "14px",
                              fontWeight: 400,
                              width: "55px",
                              textAlign: "center",
                              fontFamily: "Outfit",
                              py: 0.5,
                              borderRadius: "20px",
                            }}
                          >
                            {allViolations[ass] ? "Yes" : "No"}
                          </Box>
                        </Box>
                      ))
                    : null}
                  <Typography fontSize="26px" fontWeight={700} my={2}>
                    Candidate Feedback
                  </Typography>
                  <Card
                    sx={{
                      p: 3,
                      border: 1,
                      borderColor: "#DDE3E5",
                      borderRadius: "10px",
                    }}
                  >
                    <Rating
                      value={
                        resume?.result[0]?.candidate_feedback_for_interview
                          ?.rating || 0
                      }
                      readOnly
                      sx={{
                        color: "#FFB400",
                        "& .MuiRating-iconFilled": {
                          color: "#FFB400",
                        },
                      }}
                    />

                    <Typography
                      color="#333"
                      fontSize="14px"
                      fontFamily="Outfit"
                      fontWeight={400}
                    >
                      {resume?.result?.length &&
                      resume?.result[0]?.candidate_feedback_for_interview
                        ?.feedback
                        ? resume?.result[0]?.candidate_feedback_for_interview
                            ?.feedback
                        : "No feedback provided by the candidate"}
                    </Typography>
                  </Card>
                </Box>
                {resume?.result[0]?.tests?.length > 0 && (
                  <Box width={{ xs: "100%", md: "60%" }}>
                    <Typography fontSize="26px" fontWeight={700}>
                      Top Performance
                    </Typography>
                    <Box maxHeight={450} overflow="scroll">
                      {resume?.result[0]?.tests
                        ?.flatMap((test) => test?.questions || []) // Flatten all questions
                        ?.filter((item) => item.answer_score > 0) // Exclude 0-score answers
                        ?.sort((a, b) => b.answer_score - a.answer_score) // Sort in descending order
                        ?.slice(0, 3) // Take top 3
                        ?.map((item) => (
                          <InterviewQnaCard
                            qna={item}
                            key={item?.question}
                            language={
                              resume?.result[0]?.language
                                ? resume?.result[0]?.language
                                : "English"
                            }
                          />
                        ))}
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          )}
        </Box>
        <AttachmentsModal
          open={attachmentsModal}
          onClose={_toggleAttachementsModal}
          attachments={attachements}
        />

        <ShareResultModal
          open={openShareModal}
          onClose={_toggleShareModal}
          title={resume?.candidate_name}
          resumeId={resume?.id}
          type="interview"
        />
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDipatchToProps = {
  getSingleResume: getSingleResumeAction,
};

/* Export
============================================================================= */
export default connect(
  mapStateToProps,
  mapDipatchToProps
)(InterviewResultsCandidateOverallResult);
